'use client';
import MuiIcon from '@mui/material/Icon';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import withRef from '../../utils/withRef';

export const styles = {
  left: {
    marginRight: 4,
  },
  right: {
    marginLeft: 4,
  },
};

const useStyles = makeStyles()(styles);

export const Icon = ({ position, className, forwardedRef: ref, ...rest }) => {
  const { classes, cx } = useStyles();

  return <MuiIcon className={cx(classes[position], className)} {...rest} ref={ref} />;
};

Icon.propTypes = {
  /** Size of the icon. */
  fontSize: PropTypes.oneOf(['extraSmall', 'medium', 'small', 'large']),
  /**
   * Position of icon to indicate where margin should be added.
   * Will add margin between icon and other element children.
   */
  position: PropTypes.oneOf(['left', 'right']),
};

export default withRef()(Icon);
